import { makeStyles } from '@material-ui/styles';
import Text from '../../Text';

const useStyles = makeStyles(
    () => ({
        wrap: {
            width: '100%',
            marginTop: 160,
            '& > *': {
                textAlign: 'center',
            },
        },
        image: {
            height: 175,
        },
        title: {
            display: 'block',
            padding: '15px 0',
            marginTop: 20,
        },
        link: {
            fontSize: '1.6rem',
        },
    }),
    { classNamePrefix: 'not-found' }
);

const NotFoundErrorPage = () => {
    const classes = useStyles();
    return (
        <div className={classes.wrap}>
            <div>
                <img
                    className={classes.image}
                    src="https://res.cloudinary.com/bizzaboprod/image/upload/q_auto:best,c_crop,g_custom/v1626770394/qryfod3ai6cfkljeq7r4.png"
                    alt="404 - Page not found"
                />
                <Text className={classes.title} variant="t40">
                    The page or event you are looking for was not found
                </Text>
                <a
                    className={classes.link}
                    href={`mailto:support@bizzabo.com?subject=Page not found: ${location.href}`}
                >
                    {`Let us help you find the event you're looking for`}
                </a>
            </div>
        </div>
    );
};

export default NotFoundErrorPage;
